import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import mergeCarts from "../api-calls/merge-carts";
import getCartQueryKey from "../get-query-key";
import getCartReviewsQueryKey from "../../../cart_reviews/v2/get-query-key";
import getPartnerCartReviewsQueryKey from "../../../partner_cart_reviews/v1/get-query-key";
import getPartnerCartReviewsV2QueryKey from "../../../partner_cart_reviews/v2/get-query-key";
import handleCartErrors from "../utils/handle-errors";
import handleCartWarnings from "../utils/handle-warnings";
var getMergeCartsOptions = function getMergeCartsOptions(_ref) {
  var queryClient = _ref.queryClient;
  return {
    mutationFn: mergeCarts,
    onMutate: function onMutate() {
      return {
        meta: {
          dispatchCartUpdated: true,
          dispatchCartCountUpdated: true
        }
      };
    },
    onSuccess: function () {
      var _onSuccess = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(data) {
        return _regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // Update cart cache
              queryClient.setQueryData(getCartQueryKey(), data);
              _context.next = 1;
              return queryClient.invalidateQueries({
                queryKey: getCartReviewsQueryKey()
              });
            case 1:
              _context.next = 2;
              return queryClient.invalidateQueries({
                queryKey: getPartnerCartReviewsQueryKey()
              });
            case 2:
              _context.next = 3;
              return queryClient.invalidateQueries({
                queryKey: getPartnerCartReviewsV2QueryKey()
              });
            case 3:
              if (!(data !== null && data !== void 0 && data.warnings && data.warnings.length > 0)) {
                _context.next = 4;
                break;
              }
              _context.next = 4;
              return handleCartWarnings({
                warnings: data.warnings,
                data: data
              }, queryClient);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function onSuccess(_x) {
        return _onSuccess.apply(this, arguments);
      }
      return onSuccess;
    }(),
    onError: function () {
      var _onError = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(error, variables) {
        var _t;
        return _regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 1;
              return handleCartErrors({
                error: error,
                params: variables
              }, queryClient);
            case 1:
              _context2.next = 3;
              break;
            case 2:
              _context2.prev = 2;
              _t = _context2["catch"](0);
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 2]]);
      }));
      function onError(_x2, _x3) {
        return _onError.apply(this, arguments);
      }
      return onError;
    }()
  };
};
export default getMergeCartsOptions;